import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {hideLoader} from 'app/redux/loaderSlice'
import {ModalHeader} from '_core/components/Modal'
import customerService from 'app/services/CustomerService'
import NumberFormat from 'react-number-format'
import {setPhoneNumber} from '../../redux/fulfillment/orderSlices'

type Props = {
  onClose: (updatedPhone?: string) => void
  addressId: string
  title?: string
  selectedPhone?: string
}

const CustomerPhoneNumberDialog: FC<Props> = ({onClose, addressId, title, selectedPhone = ''}) => {
  const dispatch = useDispatch()
  const [phone, setPhone] = useState<string>(selectedPhone)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string>('')

  const validatePhoneNumber = (number: string) => {
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/
    return phoneRegex.test(number)
  }

  const handleSavePhoneNumber = async () => {
    if (!validatePhoneNumber(phone)) {
      setError('Please enter a valid phone number')
      return
    }
    setError('')
    try {
      setIsSubmitting(true)
      await customerService.updateAddress({phone, id: addressId})
      dispatch(setPhoneNumber(phone))
      dispatch(hideLoader())
      onClose(phone)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handlePhoneChange = (values: any) => {
    setPhone(values.formattedValue)
    if (error) setError('')
  }

  return (
    <Modal
      size='lg'
      id='kt_modal_phone_dialog'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='h-auto w-auto'
      show={true}
      centered
    >
      <ModalHeader title={title} toolbar={{onClick: () => onClose()}} />

      <div className='modal-body'>
        <label className='form-label'>Phone Number</label>
        <NumberFormat
          name='phone'
          placeholder='Enter phone number'
          className={`form-control ${error ? 'is-invalid' : ''}`}
          value={phone}
          onValueChange={handlePhoneChange}
          allowNegative={false}
          format='(###) ###-####'
        />
        {error && <div className='invalid-feedback'>{error}</div>}
        <div className='d-flex justify-content-end mt-4'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => onClose()}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={handleSavePhoneNumber}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span className='spinner-border spinner-border-sm me-2' role='status' />
            ) : null}
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default CustomerPhoneNumberDialog
